import {
  faBadgePercent,
  faGrid2Plus,
  faTag,
} from '@fortawesome/pro-regular-svg-icons';
import { Col, Row } from '@design-system/components/grid/grid';
import { Button } from '@design-system/components/button/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@design-system/components/typography/typography';
import {
  button,
  iconStyle,
  wrapper,
  image,
  imageWrapper,
  detailTextWrapper,
} from './EmptyState.css';
import { sprinkles } from '@design-system/sprinkles.css';
import { ExternalLink } from '@design-system/components/link/externalLink';
import SubEmptyStateImg from './subscription-empty-state.png';

type EmptyStateProps = {
  create: () => void;
};

export const EmptyState = (p: EmptyStateProps) => {
  return (
    <div className={wrapper}>
      <Col gap="xl">
        <Typography variant="headline" size="small">
          Exclusive Subscriptions are here!
        </Typography>
        <Col gap="l">
          {details.map(({ icon, title, details }) => (
            <Row key={title}>
              <FontAwesomeIcon icon={icon} className={iconStyle} />
              <div className={detailTextWrapper}>
                <Typography variant="body" size="large">
                  {title}
                </Typography>
                <Typography
                  variant="body"
                  size="medium"
                  fontWeight="normal"
                  className={sprinkles({ color: 'N-80' })}
                >
                  {details}
                </Typography>
              </div>
            </Row>
          ))}
        </Col>
        <Row gap="m">
          <Button color="neutral" className={button} onClick={p.create}>
            Start Exclusive Subscription
          </Button>
        </Row>
        <Col gap="m">
          <Typography variant="body" size="medium">
            Learn more here:
          </Typography>
          <ExternalLink
            noDecoration
            textColor="P-80"
            label="How to turn on Exclusive subscription"
            href="https://help.playbookapp.io/en/articles/13621806-how-to-turn-on-an-exclusive-subscription"
          />
        </Col>
      </Col>
      <div className={imageWrapper}>
        <img className={image} src={SubEmptyStateImg} />
      </div>
    </div>
  );
};

const details = [
  {
    icon: faGrid2Plus,
    title: "Decide what's included",
    details:
      'Instead of "everything for everyone, an exclusive subscription allows you to tailor who gets access to what. You pick who gets which programs, live videos, extras, and access to your community.',
  },
  {
    icon: faTag,
    title: 'Set your own price',
    details:
      "You choose your Exclusive subscription price. You'll be able to change this price whenever you like, so that new users always pay your most recent price.",
  },
  {
    icon: faBadgePercent,
    title: 'Add a discount',
    details:
      'Once your subscription offer is ready, consider adding a discount to create a sense of urgency for your product.',
  },
];
